import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Card from "@mui/material/Card";
// import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { motion } from "framer-motion";

import { Navbar } from "../../Components/Navbar";
import Section from "../Components/Section";
import AccordionItem from "../Components/AccordionItem";
import "./../../Bookclosure/Styles/Bookclosure.css";
import {
  getLibraryList,
  getOneBookClosure,
  importTasksFromLibrary,
} from "../Services/ApiHandler";


import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import Breadcrumb from "../../myfin_v2/components/Breadcrumb"
import { Button } from "../../myfin_v2/elements/Button"
import ModuleCard from "../../myfin_v2/elements/ModuleCard"
import "../../myfin_v2/css/module.css"
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plus.svg";

const BookClosureLibrary = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { workspaceId, companyId } = useParams();

  const { bookClosureId } = useSelector((state) => state.BookClosureReducer);

  const [activeSection, setActiveSection] = useState("");
  const [bookClosureLibrary, setBookClosureLibrary] = useState([]);
  const [taskList, setTaskList] = useState({});
  const [libraryCheckedTasks, setLibraryCheckedTasks] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isHeaderHovered, setIsHeaderHovered] = useState(false);

  useEffect(() => {
    getBookClosureData();
    if (bookClosureId) {
      GetLibraryList(bookClosureId, companyId);
    }
  }, []);

  const getBookClosureData = () => {
    const data = {
      // companies: [],
      // assignees: [],
      // approvers: [userId]
    };
    if (!bookClosureId) {
      getOneBookClosure(workspaceId, data)
        .then((response) => {
          dispatch({
            type: "BOOK_cLOSURE_DATA",
            payload: response.data.bookClosure || {},
          });

          const book_closure_id = response.data.bookClosure._id;
          GetLibraryList(book_closure_id, companyId);
        })
        .catch((error) => {
          swal(
            "Error",
            `Book Closure Error: ${error.response?.data?.error}`,
            "error"
          );
        });
    }
  };
  //
  const handleMouseEnter = (index) => {
    setHoveredRow(index);
  };

  const handleMouseLeave = () => {
    setHoveredRow(null);
  };
  //
  const handleHeaderMouseEnter = () => {
    setIsHeaderHovered(true);
  };

  const handleHeaderMouseLeave = () => {
    setIsHeaderHovered(false);
  };
  //
  const GetLibraryList = (bookClosureId, companyId) => {
    getLibraryList(bookClosureId, companyId).then(response => {
      const availableLibraries = response.data.bookClosureLibrary.filter(item => item.available);
      setBookClosureLibrary(availableLibraries);
      setTaskList(availableLibraries[0] ?? {});
      setActiveSection(availableLibraries[0].module ?? "")
      setLibraryCheckedTasks([])
    }).catch(error => {
      swal("Error", `Book Closure Error: ${error.response?.data?.error}`, 'error');
    })
  }

  const ImportLibraryTasks = () => {
    const hasUncheckedTask = libraryCheckedTasks.some(task => !task.exist);
    if (hasUncheckedTask) {
      // Show warning toast if any task is unchecked (either template or exist)
      // toast.warning("Some tasks are incomplete. Ensure all tasks have both 'template' and 'exist' checked.");
      swal("Warning", "Some tasks are incomplete. Ensure all tasks have both template and exist checked.", "warning");
      return;
    }
    const data = {
      companyID: companyId,
      workspaceID: workspaceId,
      libraryTaskData: libraryCheckedTasks.map(task => ({
        libraryTaskID: task.libraryTaskID,
        template: task.template
      }))
    }
    if (libraryCheckedTasks.length > 0) {
      importTasksFromLibrary(bookClosureId, data).then(response => {
        // toast.success("Tasks Imported Successfully.");
        swal("Success", "Tasks Imported Successfully.", 'success')
        GetLibraryList(bookClosureId, companyId);
      }).catch(error =>
        swal("Error", `Book Closure Error: ${error.response?.data?.error}`, 'error')
      )
    }
  }

  const HandleStatusChange = (event, moduleName, ix, task) => {
    const name = event.currentTarget.getAttribute('name');

    const updateTaskStatus = (tasks, ix, name) => {
      return tasks.map((task, index) =>
        index === ix ? { ...task, [name]: !task[name] } : task
      );
    };

    setLibraryCheckedTasks(prevUpdateList => {
      if (task) {
        const oldTask = { libraryTaskID: task._id, template: task?.template, exist: task?.exist };
        const newTask = { ...oldTask, [name]: !task[name] }

        const taskExists = prevUpdateList.some(t => t.libraryTaskID === task._id);
        if (taskExists) {
          // If the task exists, update the respective field (template or exist)
          const updatedList = prevUpdateList.map(t =>
            t.libraryTaskID === task._id ? { ...t, [name]: !t[name] } : t
          );
          // Find the updated task after toggle
          const updatedTask = updatedList.find(t => t.libraryTaskID === task._id);
          // If both template and exist are false, remove the task from the list
          if (!updatedTask.template && !updatedTask.exist) {
            return updatedList.filter(t => t.libraryTaskID !== task._id);
          }
          return updatedList;
        } else {
          // If the task doesn't exist, push the newTask into the list
          return [...prevUpdateList, newTask];
        }
      }
      return prevUpdateList;
    });

    setBookClosureLibrary(prevLibrary => {
      return prevLibrary.map(module => {
        if (module.module === moduleName && module.tasks && module.tasks[ix]) {
          return {
            ...module,
            tasks: updateTaskStatus(module.tasks, ix, name),
          };
        }
        return module;
      });
    });

    setTaskList((prevTaskList) => {
      if (
        prevTaskList.module === moduleName &&
        prevTaskList.tasks &&
        prevTaskList.tasks[ix]
      ) {
        return {
          ...prevTaskList,
          tasks: updateTaskStatus(prevTaskList.tasks, ix, name),
        };
      }
      return prevTaskList;
    });
  };

  const [activeTab, setActiveTab] = useState("Investments");

  const tabs = ["Investments", "Leases", "Loans", "Payables", "Receivables"];

  const breadcrumbItems = [
    {
      label: "Workspace",
      // link: `/bookclosure/${workspaceId}`,
      link: {
        pathname: `/bookclosure/${workspaceId}`,
        state: { redirectFilter: { companyID: companyId } }
      },
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Book closure",
      // link: `/bookclosure/${workspaceId}`,
      link: {
        pathname: `/bookclosure/${workspaceId}`,
        state: { redirectFilter: { companyID: companyId } }
      },
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "Import tasks from Library", link: "", className: "headerLable" },
  ];

  useEffect(() => {
    selectedTasksTemplates();
  }, [bookClosureLibrary])

  const [selTaskCount, setSelTaskCount] = useState(0);
  const [selTemplateCount, setSelTemplateCount] = useState(0);
  const selectedTasksTemplates = () => {
    let taskCount = 0;
    let templateCount = 0;
    if (bookClosureLibrary.length > 0) {
      bookClosureLibrary.forEach((section) => {
        if (section.available && section.tasks.length > 0) {
          section.tasks.forEach((task) => {
            if (task.exist) {
              taskCount++;
            }
            if (task.template) {
              templateCount++;
            }
          });
        }
      });
    }

    setSelTaskCount(taskCount);
    setSelTemplateCount(templateCount);
  };


  useEffect(() => {
    console.log("selTaskCount,selTemplateCount", selTaskCount, selTemplateCount);

  }, [selTaskCount, selTemplateCount])


  console.log("taskList",taskList);
  

  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 0, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }} className={`${commoncss.pageContent} ${commoncss.bgClr1} `}>
          <Breadcrumb
            addCls={"bgClr1"}
            items={breadcrumbItems}
            headerActions={<></>}
          />
          <div className="library-container">
            <div className="moduleHeader">
              <h2 className="moduleHeaderTitle my-1">Modules Library</h2>
              <div className="selected-info">
                <div className="selLib">
                  <span className="selected-count ml-2">SELECTED</span>
                  <span className={commoncss.dFlexJustifysb} style={{ "gap": "2px" }}>
                    <span className="count">{selTemplateCount} Templates</span> <span className="count">{selTaskCount} Tasks</span></span>
                </div>
                <Button
                  label="Import tasks"
                  btnColor={buttoncss.primary}
                  icon={<PlusIcon />}
                  onClick={() => ImportLibraryTasks()}
                />
              </div>
            </div>
            {bookClosureLibrary &&
              bookClosureLibrary.length > 0 &&
              bookClosureLibrary.map((section, index) => (
                <button
                  key={index}
                  className={`tab-button ${section.module === activeSection ? "active" : ""}`}
                  onClick={() => {
                    setActiveSection(section.module);
                    const findLibData = bookClosureLibrary.find(
                      (ele) => ele.module === section.module
                    );
                    setTaskList(findLibData);
                  }}
                  style={{ "text-transform": "capitalize", "border-bottom": "unset" }}
                >
                  {section.module}
                </button>
              ))}
            <div className="modulecards-grid" style={{ "border-top": "1px solid #dddddd" }}>
              {taskList?.tasks &&
                taskList.tasks.length > 0 &&
                taskList.tasks.map((task, ix) => {
                  const colIndex = ix % 3; // 0-based column ix in 5-column layout

                  // Define variation sets
                  const leftToRightVariants = [
                    { x: -120, y: -10, duration: 0.4 },
                    { x: -100, y: 5, duration: 0.6 },
                    { x: -150, y: 15, duration: 0.5 }
                  ];

                  const rightToLeftVariants = [
                    { x: 120, y: -10, duration: 0.4 },
                    { x: 100, y: 10, duration: 0.6 },
                    { x: 140, y: 20, duration: 0.5 }
                  ];

                  const middleColumnVariants = [
                    { x: -80, y: 0, duration: 0.5 },
                    { x: 80, y: 0, duration: 0.5 },
                    { x: 0, y: -100, duration: 0.6 },
                    { x: 0, y: 100, duration: 0.4 },
                    { x: -100, y: -100, duration: 0.7 }
                  ];

                  // Pick variant based on column
                  let variant;
                  if (colIndex <= 1) {
                    variant = leftToRightVariants[ix % leftToRightVariants.length];
                  } else if (colIndex >= 3) {
                    variant = rightToLeftVariants[ix % rightToLeftVariants.length];
                  } else {
                    variant = middleColumnVariants[ix % middleColumnVariants.length];
                  }
                  return (
                    <motion.div
                      initial={{ x: variant.x, y: variant.y, opacity: 0 }}
                      animate={{ x: 0, y: 0, opacity: 1 }}
                      transition={{ duration: variant.duration, ease: "easeOut" }} name="exist" className={`modulecard clickable ${task.exist ? "active-module" : ""}`} style={{ "height": "220px" }} key={ix}

                      onClick={(event) =>{
                        if (!task.isImported) { 
                          HandleStatusChange(event, taskList?.module, ix, task)}
                        }
                      }
                        
                      >
                      <span>
                        <span className="modulecard-title truncate-2">{task?.name}</span>
                        {/* <p className="modulecard-description mt-0">{task?.description}</p> */}
                        <p className="modulecard-description truncate-4">{task?.description}</p>
                      </span>

                      {task.hasTemplate && (
                        <span className="module-toggles">

                          <div className="toggle-item">
                            <div className={`toggle-container`}>
                              <label className="switch">
                                <input type="checkbox"
                                  checked={task.template}
                                  disabled={task.isImported || !task.hasTemplate}
                                  name="template" id={`check_task_${ix}`} onChange={(event) =>
                                    HandleStatusChange(event, taskList?.module, ix, task)

                                  } />
                                <span className="slider round"></span>
                              </label>

                              <span className="toggle-label" htmlFor={`check_task_${ix}`}>Template {!task.hasTemplate && ("(N/A)")}</span>
                            </div>
                          </div>

                        </span>
                      )}
                    </motion.div>
                  )
                })}
            </div>
          </div>



        </motion.div>
      </div>
    </>
  );
};

export default BookClosureLibrary;
